<template>
  <div>
    <modal id="signSchedule" size="lg" class="skintestblock" v-model="modal" :append-to-body="true"
           :backdrop="false">
      <h4 slot="title" class="smalltitle">Clone To Clinic</h4>
<!--      <div class="prolabel">Registered Name</div>-->
<!--      <div class="profield"><input v-model="registeredName" type="text" autofocus></div>-->
      <div class="prolabel">Sign-in Email</div>
      <div class="profield"><input v-model="email" type="text" autofocus></div>
      <div class="prolabel">Password</div>
      <div class="profield"><input v-model="password" type="password"></div>
      <div class="prolabel">Business name</div>
      <div class="profield"><input v-model="businessName" type="text"></div>
      <div class="prolabel">WikiAllergies email username</div>
      <div class="profield">
        <input v-model="userName" type="text">
        <br>
        <em class="ng-binding">Choose an username for your email address {{ userName }}@wikiallergies.com</em>
      </div>
      <div class="prolabel">Phone Number</div>
      <div class="profield">
        <the-mask :mask="maskPhone" type="text" :masked="maskData" v-model="phoneNumber"
                  :placeholder='phonePlaceHolder'></the-mask>
      </div>
      <div slot="footer">
        <button type="button" class="btn btn-default" @click.prevent="sendNotificationForDoctor">
          <i class="fas fa-spinner fa-spin" v-if="processingStatus"></i> Send link clone to doctor
        </button>
        <button type="button" class="btn btn-default" @click.prevent="cloneToClinic">
          <i class="fas fa-spinner fa-spin" v-if="processingStatus"></i> Create
        </button>
        <button type="button" class="btn btn-default" @click.prevent="closeModal">Close
        </button>
      </div>
    </modal>
  </div>

</template>

<script>
import httpClient from '../../../client'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'

export default {
  name: 'CloneToClinic',
  components: { },
  props: {
    user: { required: true }
  },
  mixins: [CommonMixin],
  data () {
    return {
      modal: false,
      registeredName: '',
      email: '',
      password: '',
      businessName: '',
      userName: '',
      phoneNumber: '',
      processingStatus: false,
      maskPhone: '(###) ###-####',
      maskData: false,
      phonePlaceHolder: '(xxx) xxx-xxxx'
    }
  },
  computed: {},
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
  },
  beforeDestroy () {},
  methods: {
    async cloneToClinic () {
      if (this.processingStatus) {
        return
      }
      if (!this.email) {
        this.alertError('Please fill out email')
        return
      }
      if (!this.password) {
        this.alertError('Please fill out password')
        return
      }
      if (!this.businessName) {
        this.alertError('Please fill out business name')
        return
      }
      if (!this.userName) {
        this.alertError('Please fill out userName')
        return
      }
      if (!this.phoneNumber) {
        this.alertError('Please fill out phone')
        return
      }
      try {
        let data = {
          userId: this.user.id,
          email: this.email,
          password: this.password,
          businessName: this.businessName,
          userName: this.userName,
          phoneNumber: this.phoneNumber
        }
        this.processingStatus = true
        let response = await httpClient.post(`/doctor/clone-to-clinic`, data)
        this.processingStatus = false
        if (response.data.s === 200) {
          this.closeModal()
          this.$emit('updateCreateId', response.data.idClinicWiki)
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processingStatus = false
        this.alertError('Server error when set new password ')
      }
    },
    closeModal () {
      this.modal = false
    },
    async sendNotificationForDoctor () {
      if (this.processingStatus) {
        return
      }
      try {
        let data = {
          userId: this.user.id
        }
        let response = await httpClient.post(`/doctor/send-notification-to-clone-to-clinic`, data)
        this.processingStatus = false
        if (response.data.s === 200) {
          this.alertSuccess('Sent Notification Successfully: ' + response.data.url)
          this.$emit('sendNotification', response.data.token)
          this.closeModal()
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processingStatus = false
        console.log('e', e.message)
        this.alertError('Server error when cloneClinic ')
      }
    }
  }
}
</script>
<style scoped="">

</style>
